// API base URL.
//
// Local development: set REACT_APP_API_URL in .env.development (committed,
// already points at the Rails dev server). Restart `npm start` after editing
// any .env file — CRA reads them only at startup.
//
// Production: `yarn build` runs with NODE_ENV=production and does not load
// .env.development, so the fallback below is what ships. Leave it pointing at
// production so a build can never accidentally target a local machine.
const baseUrl = process.env.REACT_APP_API_URL || 'https://www.kadro.co/app/api/v4';

export default baseUrl;
